// src\themes\tolica\layouts\default.tsx
import { ReactNode } from 'react';
import Header from '../elements/Header/Header';
import Footer from '../elements/footer/Footer';
import { OrganizationSchema } from '@/components/main/seo/OrganizationSchema';
import SupportWidget from '../components/AdminSupportButton';
import { getSettings } from '@/core/lib/api/account/settings';

export default async function MainLayout({
    children,
}: Readonly<{
    children: ReactNode;
}>) {
    const settingsRes = await getSettings().catch(() => null);
    const isSupportActive = settingsRes?.data?.support_widget_active !== 'deactive';

    return (
        <>
            <OrganizationSchema />
            <Header />
            <main className="flex bg-primary-0 flex-col bg-r min-h-[calc(100vh-72px)]">
                <div className="min-h-full">{children}</div>
            </main>
            <SupportWidget active={isSupportActive} />
            <Footer />
        </>
    );
}